module.exports = __webpack_public_path__ + "static/media/gifTooltip.7b6aaf66.gif";


//////////////////
// WEBPACK FOOTER
// ./src/containers/client/images/gifTooltip.gif
// module id = 306
// module chunks = 16